export default __webpack_public_path__ + "static/media/bg-1.f6776047.jpg";